import React, { Component } from "react";
// import axios from 'axios';
import API from '../servicios/api';
import EMPLEADOS_FOTOS from '../servicios/empleadosFotos';

class UploadDisplaySaveImage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            image: null,
            MainImage: null,
            filetype: ""
        };

        // if we are using arrow function binding in not required
        //  this.onImageChange = this.onImageChange.bind(this);
    }

    componentDidMount(){
        const foto = this.props.foto;
        if (foto!=="" || foto!==undefined || foto!==null){
            this.setState({
                image: EMPLEADOS_FOTOS + foto
            });
        }
    };

    onImageChange = event => {
        if (event.target.files && event.target.files[0]) {
            let img = event.target.files[0];
            this._saveImage(img);
            this.setState({
                image: URL.createObjectURL(img)
            });
        }
    };

    _saveImage = (img) => {
        // console.log(img.name); 
        // Update the formData object 
        let data = new FormData();
        data.append('claveAPI', this.props.claveAPI);
        data.append('docId', this.props.docId);
        data.append('foto', this.props.foto);
        // data.append('perfil_image', new Blob(XXXX, { type: 'image/jpg' }));
        data.append('perfil_image', img, img.name);
        
        // this works a la antigua
        let request = new XMLHttpRequest();
        request.open('POST', API +"?saveImage");
        request.send(data);

        // Esto no funciona
        // const config = { headers: { 'Content-Type': 'multipart/form-data' } };
        // axios.post(API +"?saveImage", data, config).then(req => {
        //     console.log('Req done: ', req)
        // }).catch(err => {
        //     console.error('Error: ', err)
        // })

        // Request made to the backend api 
        // Send formData object to my php file for save in folder
        // const url = "http://localhost/~ernesto/FunFarallones/2022/empleadosAPI/saveImage.php";
        // axios.post(API +"?saveImage", formData, {'Content-Type': 'multipart/form-data'}); 
        // axios.post(url, formData,{
        //     // headers: {
        //     //     'Content-Type': 'application/x-www-form-urlencoded',
        //     //     'X-Requested-With': 'XMLHttpRequest'
        //     //   }
        //   }).then(function(response) {
        //     // handle success
        //     console.log(response);
        //   })
        //   .catch(function(error) {
        //     // handle error
        //     console.log(error);
        //   })
        //   .finally(function() {
        //     // always executed
        //   });
    }; 

    // onChangeMainImage = e => {
    //     const file = e.target.files[0];
    //     return new Promise((resolve, reject) => {
    //         const reader = new FileReader();
    //         reader.onload = (event) => {
    //             resolve(event.target.result);
    //             this.setState({ MainImage: event.target.result.split(',')[1] })
    //             var type = event.target.result.split('/')[1];
    //             this.setState({ filetype: type.split(';')[0] })
    //             //this.setState({file:event.target.result})
    //         };
    //         reader.onerror = (err) => {
    //             reject(err);
    //         };
    //         reader.readAsDataURL(file);
    //     });

    // };

    render() {
        return (
            <div>
                <div>
                    <div className="foto-container">
                        <img className="foto-empleado" src={this.state.image} alt="" />
                        <div>Foto Empleado</div>
                        <input type="file" name="perfil_image" onChange={this.onImageChange} />
                    </div>
                </div>
            </div>
        );
    }
}
export default UploadDisplaySaveImage;